/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';

	console.log(a);
	console.log(v);

	const fadeSustainableWorld = () => {
		let $header = $('.mod-top_news_block');
		let timer, flag;

		$(window).scroll((e) => {
			let thisScroll = $(e.currentTarget).scrollTop();

			if (timer) clearTimeout(timer);
			if (thisScroll === 0 && flag) {
				$header.removeClass('is-move');
				flag = false;
			} else if (thisScroll > 0 && !flag) {
				$header.addClass('is-move');
				flag = true;
			}
		});
	}
	fadeSustainableWorld()
})(window.jQuery, window.FUNCTIONS);
